export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/shopify.ac966287.svg","height":32,"width":113};